import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

const Clickable = styled.a`
  ${({ padding = '0.75rem', borderRadius = 300 }) => css`
    padding: ${padding};
    display: inline-block;
    cursor: pointer;
    color: var(--neutral-800);
    ${mixin.borderRadius({ size: borderRadius })}

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: var(--neutral-800);
      text-decoration: none;
    }
  `}
`;

export default Clickable;
